import React, { useState, useEffect } from 'react'

import { IconPlus, IconEdit } from 'components/ui/icons'
import { Button, ButtonGroup } from 'components/ui/button'
import { PrimaryNavigationEditEntity } from 'components/ui/primary-navigation/edit-entity'
import { StatusGuard } from 'components/ui/status-guard'
import { SectionHeader } from 'components/ui/section-header'

import { SharedActionCreators, sharedActionCreators } from 'containers/shared'
import { connect } from 'containers/store'

import { actionCreators, GettyActionCreators } from 'domains/org/getty/actions'
import { GettyStore, GettyAppState } from 'domains/org/getty/store'

import { ListVisitorTypesRequest } from 'generated/mos/org/getty/audioaccess'

import { statusSelector } from 'helpers/status'
import { pick, pluralise } from 'helpers/core'

import { LayoutListOrFormPage } from 'layouts/list-or-form-page'

import { ListItem } from "./list-item";
import { VisitorTypeCreate } from "./visitor-type-create";
import { VisitorType } from "generated/mos/org/getty/audio";

type ActionProps =
  Pick<GettyActionCreators, 'gettyListVisitorTypesRequest'> &
  Pick<SharedActionCreators, 'toastNotification'>

type ConnectedProps = Pick<GettyAppState, 'visitorTypes' >

type DirectProps = {
  projectId: string;
  historyPush: (id: string) => void;
  navBackRoute?: string;
};
type Props = ActionProps & ConnectedProps & DirectProps;

const VisitorTypesView = (props: Props) => {
  const {
    projectId,
    gettyListVisitorTypesRequest,
    toastNotification,
    visitorTypes,
    historyPush,
  } = props

  const data = statusSelector.data(props.visitorTypes)
  const visitorTypesCount = data ? data.length : 0

  const [createModalOpen, setCreateModalOpen] = useState(false);

  const onCreate = (visitorType: VisitorType.Entity) => {
    setCreateModalOpen(false);
    toastNotification({ type: 'success', text: 'Visitor Type added', durationMs: 2000 });
    const visitorTypeId = VisitorType.mustRef(visitorType.ref).id
    historyPush(`/project/${projectId}/visitor-type/${visitorTypeId}`)
  }

  useEffect(() => {
    gettyListVisitorTypesRequest({
      ...ListVisitorTypesRequest.defaults,
    })
  }, [gettyListVisitorTypesRequest, projectId, toastNotification]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <LayoutListOrFormPage
      nav={() => (
        <PrimaryNavigationEditEntity
          title="Edit Project"
          navBackRoute={props.navBackRoute}
          darkTheme
        />
      )}
      title="GettyGuide"
      subnav={() => (
        <>
          <Button variant="subtle" onClick={() => setCreateModalOpen(true)}><IconPlus size="small" />
            <strong> create visitor type</strong>
          </Button>
        </>
      )}
      content={() => (
        <>
          {createModalOpen &&
            <VisitorTypeCreate
              onCancel={() => setCreateModalOpen(false)}
              onComplete={onCreate}
            />
          }
          <StatusGuard status={visitorTypes}>
            <SectionHeader heading={`${visitorTypesCount} ${pluralise(visitorTypesCount, "visitor type", "visitor types")}`} />
            {data && data.map(visitorType => (
              <ListItem
                key={VisitorType.mustRef(visitorType.ref).id}
                visitorType={visitorType}
                historyPush={historyPush}
                projectId={projectId}
                />
              ))}
          </StatusGuard>
        </>
      )}
    />
  )
}

export const VisitorTypes = connect<ConnectedProps, ActionProps, DirectProps, GettyStore, GettyActionCreators>(
  (store) => ({
    ...pick(store.getty, 'visitorTypes'),
  }),
  {
    ...pick(actionCreators, 'gettyListVisitorTypesRequest'),
    ...pick(sharedActionCreators, 'toastNotification'),
  }
)(VisitorTypesView)
